// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask_mask__kgmVl","mask_aria_button":"mask_mask_aria_button__tQP_d","normal_content":"mask_normal_content__SHUHO","dialog_content":"mask_dialog_content__QpxFu"};